<!--人员管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="1" :ssid="ssid"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="机构名称： ">
                  <el-input
                    placeholder="请输入机构名称..."
                    v-model="search.COMPANY_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">姓名：</label>
                  <el-input
                    placeholder="请输入姓名..."
                    v-model="search.NAME"
                  ></el-input>
                  <label style="margin-left:6px;">手机号：</label>
                  <el-input
                    placeholder="请输入手机号..."
                    v-model="search.PHONE"
                  ></el-input>
                  <label style="margin-left:6px;">权限类型：</label>
                   <el-select placeholder="请选择" v-model="search.PERMISSION_ID">
                    <el-option label="管理员" value="99"></el-option>
                    <el-option label="店东" value="1"></el-option>
                    <el-option label="经纪人" value="2"></el-option>
                    <el-option label="收房人" value="3"></el-option>
                    <el-option label="出房人" value="4"></el-option>
                    <el-option label="配饰人员" value="5"></el-option>
                    <el-option label="装修公司" value="0"></el-option>
                  </el-select>
                  <label style="margin-left:6px;">是否启用：</label>
                   <el-select placeholder="请选择" v-model="search.IS_ENABLED">
                    <el-option label="已启用" value="1"></el-option>
                    <el-option label="未启用" value="0"></el-option>
                  </el-select>
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <div style="float:right;margin-right:10px;">
                    <upload-curr-com
                        :mainLoadData="mainLoad"
                        :op="op"
                        :paramData="search"
                        :tableColumns="tableColumns"
                        mbBtnTxt="导出表格"
                        isUpLoadBtn="0"
                        isDownBtn="1"
                    ></upload-curr-com>
                </div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
            <template slot-scope="scope">
                <div v-if="col.colName==='PERMISSION_ID'||col.colName==='IS_ENABLED'">
                    <div v-if="col.colName==='PERMISSION_ID'">
                        <span v-if="scope.row.PERMISSION_ID==='99'">管理员</span>
                        <span v-if="scope.row.PERMISSION_ID==='1'">店东</span>
                        <span v-if="scope.row.PERMISSION_ID==='2'">经纪人</span>
                        <span v-if="scope.row.PERMISSION_ID==='3'">收房人</span>
                        <span v-if="scope.row.PERMISSION_ID==='4'">出房人</span>
                        <span v-if="scope.row.PERMISSION_ID==='5'">配饰人员</span>
                        <span v-if="scope.row.PERMISSION_ID==='0'">装修公司</span>
                    </div>
                    <div v-else>
                        <span v-if="scope.row.IS_ENABLED==='0'" style="color:red">未启用</span>
                        <span v-if="scope.row.IS_ENABLED==='1'" style="color:green">已启用</span>
                    </div>
                </div>
                <div v-else>
                    {{scope.row[col.colName]}}
                </div>
            </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                @click="roleBgHandler(scope.row)"
                type="text"
                size="small"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->

      <!-- 权限变更 开始 -->
      <el-dialog
        :title="'权限变更'"
        :visible.sync="dialogVisible"
        width="50%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                  <label
                    >&nbsp;&nbsp;请选择权限<span style="color:red;">*</span
                    >：</label
                  >
                  <el-select placeholder="请选择" v-model="row.PERMISSION_ID">
                    <el-option label="管理员" value="99"></el-option>
                    <el-option label="店东" value="1"></el-option>
                    <el-option label="经纪人" value="2"></el-option>
                    <el-option label="收房人" value="3"></el-option>
                    <el-option label="出房人" value="4"></el-option>
                    <el-option label="配饰人员" value="5"></el-option>
                    <el-option label="装修公司" value="0"></el-option>

                  </el-select>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label
                    >&nbsp;&nbsp;是否启用<span style="color:red;">*</span
                    >：</label
                  >
                   <el-select placeholder="请选择" v-model="row.IS_ENABLED">
                    <el-option label="已启用" value="1"></el-option>
                    <el-option label="未启用" value="0"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="roleServerBgHandler">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 权限变更 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "PersonGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {
      },
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "USER_ID",
          colText: "人员ID",
          colShow: false
        },
        {
          colName: "NAME",
          colText: "人员姓名",
          colShow: true
        },
        {
          colName: "PHONE",
          colText: "手机号",
          colShow: true
        },
        {
          colName: "ID_CARD",
          colText: "证件号",
          colShow: true
        },
        {
          colName: "PERMISSION_ID",
          colText: "权限",
          colShow: true
        },
        {
          colName: "ORG_ID",
          colText: "机构码",
          colShow: true
        },
        {
          colName: "IS_ENABLED",
          colText: "是否启用",
          colShow: true
        },
        {
          colName: "CREATE_TIME",
          colText: "创建时间",
          colShow: true
        },
        {
          colName: "COMPANY_NAME",
          colText: "公司名称",
          colShow: true
        },
        {
          colName: "REVIEW_DATE",
          colText: "审核日期",
          colShow: false
        },
        {
          colName: "REVIEW_TIME",
          colText: "审核时间",
          colShow: true
        }
      ],
      tableData: [],
      row:{},
      dialogVisible:false
    };
  },
  created() {
    this.op = "adminPersonGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      //alert(JSON.stringify(this.pageSet));
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    roleBgHandler(row){
        this.row=row;
        this.dialogVisible=true
    },
    /**分页方法 结束 */
    roleServerBgHandler(){
      if(!confirm('是否进行变更？')){
            return;
        }
        var busData = {
            row:this.row
        };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "roleServerBgHandler" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
         alert(data.msg);
        if (data.isSuccess) {
            this.mainLoad();
            this.dialogVisible=false
          return;
        }
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/personGlIndex/PersonGlIndex.vue